import { render, staticRenderFns } from "./AutomationWizardFormField.vue?vue&type=template&id=2c8b0673&"
import script from "./AutomationWizardFormField.vue?vue&type=script&lang=js&"
export * from "./AutomationWizardFormField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports